import UploadingFile from './UploadingFile.component';

export default UploadingFile;